import { render, staticRenderFns } from "./otherClientList.vue?vue&type=template&id=508cf1f4"
import script from "./otherClientList.vue?vue&type=script&lang=js"
export * from "./otherClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports